import { takeEvery } from 'redux-saga/effects';

import * as payoutActions from 'store/modules/payouts';

import { remove } from './utils';

export default function* listenRemove() {
  yield takeEvery(payoutActions.remove.toString(), remove);
}
